<template>
  <div v-if="networks.length > 1">
    <CriteriaNetworkMultiple />
  </div>
  <div v-else>
    <CriteriaNetworkSingle />
  </div>
</template>

<script setup>
const { networks } = useFCPModel()

</script>